import React, { useState } from 'react';
import { Space, Dropdown, Menu, Modal, Typography } from 'antd';
import CatalogVendorOptionFormModal from './CatalogVendorOptionFormModal';
import { MoreOutlined } from '@ant-design/icons';

const { Link } = Typography;

const ActionsColumn = ({ columnData, onUpdateVendorOption, onDeleteVendorOption }) => {

  const [editModalVisible, setEditModalVisible] = useState(false);

  const renderContent = () => {
    return (
      <div style={{ paddingTop: 12, paddingBottom: 30 }}>Are you sure you want to delete this Vendor Option</div>
    )
  };

  const confirmDelete = () => {
    Modal.confirm({
      title: `Remove Vendor Option`,
      icon: '',
      content: renderContent(),
      closable: true,
      okText: `REMOVE`,
      onOk() {
        onDeleteVendorOption({ id: columnData.id, mode: columnData.mode });
      },
      cancelButtonProps: { style: { display: 'none' } }
    });
  };

  const onUpdateSubmit = (value) => {
    let payloadObj = {
      id: columnData.id,
      payload: value
    }
    onUpdateVendorOption(payloadObj);
  }

  return (
    <Space>
      {editModalVisible === true ?
        <CatalogVendorOptionFormModal
          columnData={columnData}
          onSubmit={(val) => onUpdateSubmit(val)}
          onCancel={() => setEditModalVisible(false)}
          visible={editModalVisible}
          title="Edit Vendor Option"
          submitText="UPDATE"
        />
        : ''}
      <Dropdown
        overlay={(
          <Menu>
            <Menu.Item key="0" onClick={() => setEditModalVisible(true)}>
              <span>
                Edit Vendor Option
              </span>
            </Menu.Item>
            <Menu.Item key="1" onClick={confirmDelete}>
              <span>
                Delete Vendor Option
              </span>
            </Menu.Item>
          </Menu>
        )}
        trigger={['click']}
      >
        <Link className="ant-dropdown-link" onClick={(e) => e.preventDefault()}>
          <MoreOutlined className="moreOutlined" />
        </Link>
      </Dropdown>
    </Space>
  );
}
export default ActionsColumn;
